export const defaultHeroImage = '/images/hintergrund_new.png';

export function getHeroStyle(overlayOpacity = 0.5, position = 'center') {
  return {
    backgroundImage: `linear-gradient(rgba(0,0,0,${overlayOpacity}), rgba(0,0,0,${overlayOpacity})), url(${process.env.PUBLIC_URL}${defaultHeroImage})`,
    backgroundSize: 'cover',
    backgroundPosition: position
  };
}
